<template>
  <div>
    <p>{{ oneText }}</p>
    <div>
      <p v-for="item in twoText" :key="item" class="auth-item" style="white-space: normal">{{ item }}</p>
    </div>
    <div>
      <p v-for="item in threeText" :key="item" class="text-right" style="white-space: normal">{{ item }}</p>
    </div>
    <!-- <p>
      <b>尊敬的用户：</b>
    </p>
    <p class="auth-item">为保护用户权益，保障新老客户软件正常运行及升级换代等增值服务，根据售后服务条款相关规定，现正式通知如下：</p>
    <p class="auth-item">贵单位的软件服务已到期，请贵单位相关负责人，尽快联系我公司商务，洽谈服务续签事宜，联系电话：177-8893-2736。</p>
    <p class="text-right">湖南联羿科技有限公司</p>
    <p class="text-right">客户服务中心</p> -->
  </div>
</template>

<script>
export default {
  name: 'AuthMsg',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      oneText: '',
      twoText: [],
      threeText: []
    };
  },
  created() {
    const arrStr = this.msg.split('$$');
    if (arrStr.length > 0) {
      this.oneText = arrStr[0];
      let twoText = [];
      const twoData = arrStr[1] ? arrStr[1].split('@!') : [];
      twoData.forEach(element => {
        twoText.push(element);
      });
      this.twoText = twoText;
      let threeText = [];
      const threeData = arrStr[2] ? arrStr[2].split('@!') : [];
      threeData.forEach(element => {
        threeText.push(element);
      });
      this.threeText = threeText;
    }
  }
};
</script>

<style lang="less" scoped>
.auth-item {
  text-indent: 27px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/platform/auth-msg.vue